export default "__VITE_ASSET__D3YsL6JY__"